import React, {useEffect, useState} from 'react';

import {Indicator, NativeInput, Option, RadioButtonLabel, RadioButtonRoot} from './styled';

interface RadioButtonProps {
    options: RadioButtonOption[];
    onChange?: (item: RadioButtonOption) => any;
    direction?: 'horizontal' | 'vertical';
    value?: RadioButtonOption;
    className?: string;
}

export type RadioButtonOption = {
    value: string;
    label?: string;
    onChange?: (value: string) => any;
};

export const RadioButton = ({
    options,
    onChange,
    value,
    direction = 'horizontal',
    className,
}: RadioButtonProps) => {
    const [selectedOption, setSelectedOption] = useState(value ?? options[0].value);

    // Controlled input
    useEffect(() => {
        if (value) {
            setSelectedOption(value);
        }
    }, [value]);

    const change = (option: RadioButtonOption) => {
        if (!value) {
            // If uncontrolled input
            setSelectedOption(option.value);
        }

        onChange?.({label: option.label, value: option.value});
        option.onChange?.(option.value);
    };

    const isChecked = (option: RadioButtonOption): boolean =>
        value ? value.value === option.value : option.value === selectedOption;

    return (
        <RadioButtonRoot direction={direction} className={className}>
            {options.map((option) => (
                <Option key={option.value}>
                    <NativeInput
                        checked={isChecked(option)}
                        onChange={() => change(option)} // Change on arrow keys
                        type="radio"
                        value={option.value}
                    />
                    <Indicator
                        onClick={() => change(option)} // Change on fake indicator click
                        checked={option.value === selectedOption}
                    />
                    <RadioButtonLabel htmlFor={option.value}>
                        {option.label ?? option.value}
                    </RadioButtonLabel>
                </Option>
            ))}
        </RadioButtonRoot>
    );
};
